import { render, staticRenderFns } from "./DashboardPagamento.vue?vue&type=template&id=22c196de&scoped=true&lang=html&"
import script from "./DashboardPagamento.vue?vue&type=script&lang=js&"
export * from "./DashboardPagamento.vue?vue&type=script&lang=js&"
import style0 from "./DashboardPagamento.vue?vue&type=style&index=0&id=22c196de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c196de",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/custom/abbrasil/spa/dashboard/cadeia/DashboardPagamento.vue
// module id = 1242
// module chunks = 28